import { isEmpty } from './is-empty.js';

export function isBase64(value: string): boolean {
  if (isEmpty(value)) {
    return false;
  }

  /**
   * Строка base64 должна:
   * 1. Содержать только допустимые символы (A-Z, a-z, 0-9, +, /)
   * 2. Иметь длину, кратную 4
   * 3. Может содержать = только в конце, и не более двух
   */
  return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(
    value
  );
}
